import { diContainer } from "@/inversify.config";
import {
  PainelDeIntegracaoesGateway,
  TWebservice
} from "../services/PainelDeIntegracaoesGateway";
import { IToastNotification } from "@/core/composables/notification/types";
import { DITypes } from "@/core/@types/types";

export default function useDeletarIntegracao(
  gateway: PainelDeIntegracaoesGateway
) {
  const notification = diContainer.get<IToastNotification<string>>(
    DITypes.NOTIFICATION
  );

  const deletarIntegracao = async (row?: TWebservice): Promise<boolean> => {
    if (!row) return false;

    try {
      // TODO[FINC-1622]: mover bloqueio de exclusão do CieloAPI para o backend.
      if (row.Webservice == "CieloAPI") {
        notification.showNotification(
          "Esse webservice não pode ser excluido, pois é uma permissão para acessarmos os arquivos da CIELO.",
          { type: "error" }
        );

        return false;
      }
      const response = await gateway.deletarIntegracao(row._id ?? row.id ?? "");

      if (!response?.Ok) {
        notification.showNotification(
          response?.Error ?? "Erro ao deletar integração",
          { type: "error" }
        );

        return false;
      }

      notification.showNotification("Integração deletada com sucesso", {
        type: "success"
      });

      return true;
    } catch (error) {
      console.error(error);

      return false;
    }
  };

  return {
    deletarIntegracao
  };
}
